<h2 mat-dialog-title>
  {{title}}
</h2>

<mat-dialog-content>
  @if (Saving) {
    <div fxFlexFill fxLayout="column" fxLayoutAlign="center center">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
  } @else {
    @if (IsError) {
      <div style="white-space: pre-wrap;">{{ErrorMessage}}</div>
    } @else {
      <div style="white-space: pre-wrap;">{{ValidationMessage}}</div>
    }
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  @if (!Saving) {
    <button mat-button color="primary" (click)="close()" telemetry="Submission-SavingDialogOK">
      OK
    </button>
  }
</mat-dialog-actions>


